import Button from '@eduzz/houston-ui/Button';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import React from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';
import affiliateService from 'v2/services/affiliate';

import { useStyles } from './styles';

export const Export = () => {
  const classes = useStyles();

  const [loading] = useObservable(() => affiliateService.loadingExporting(), []);
  const [handleClickExport] = useCallbackObservable(() => affiliateService.export(), []);
  const [totalItems] = useObservable(() => affiliateService.getTotalItems(), []);

  return (
    <Button
      className={classes.exportBtn}
      id='leads-export-button'
      data-testid='leads-export-button'
      disabled={!totalItems}
      loading={loading}
      onClick={handleClickExport}
      variant='text'
      startIcon={<SystemUpdateAltIcon />}
    >
      {!loading ? 'Exportar' : 'Exportando...'}
    </Button>
  );
};
